import Form from "antd/lib/form";
import Select from "antd/lib/select";
import React from "react";
import { getImageBaseUrl } from "../services/s3-utils";

function BaseSelect({
  className,
  label,
  name,
  placeholder,
  selectClassName,
  options,
  rules,
  testid,
  ...props
}) {
  return (
    <label className={`w-full ${className}`}>
      <span className="text-main font-medium p-xs">{label}</span>
      <div className="relative">
        <Form.Item rules={rules} className="!mb-0 relative" name={name}>
          <Select
            placeholder={placeholder}
            className={`w-full country-select main-input h-[58px] rounded-md focus:outline-none ${selectClassName}`}
            size="large"
            options={options}
            data-testid={testid}
            {...props}
          />
        </Form.Item>

        <img
          src={`${getImageBaseUrl}/assets/caret-down.svg`}
          className="absolute right-4 top-6 w-[17px] h-2.5 pointer-events-none"
          alt=""
        />
      </div>
    </label>
  );
}

export default BaseSelect;
